import { DescriptionRegID, HardcodedFK, ImageBasic, NameRegID, TrackedDates } from '@old/typed/core/base';
import { LanguageTypeID } from '@old/typed/domain/language-type.types';
import { Prettify } from '@old/typed/extra/utils';

// database table ref: silobag_species_types
// database table ref: silobag_species_types_translations

/* EXPORTING AREA */

// TYPES SECTION
export type Species = Prettify<TrackedDates & CoreData & ImageData & RegistryData>;
export type SpeciesLocale = Prettify<ES | PT>;

// CONSTANT SECTION
export enum SpeciesID {
  WHEAT = 1, // Trigo
  SOYBEAN = 2, // Soja
  SUNFLOWER = 3, // Girasol
  SORGHUM = 4, // Sorgo
  RICE = 5, // Arroz
  CORN = 6, // Maíz
  BARLEY = 23, // Cebada
  BEAN = 24, // Poroto
  SESAME = 25, // Sésamo
  CHIA = 26, // Chia
  MILLET = 27, // Milheto
  RYE = 28, // Centeno
  CHICKPEA = 29, // Garbanzo
  SAFFLOWER = 30, // Cartamo
  OATMEAL = 31, // Avena
  PEA = 32, // Arveja
}

/* PRIVATE TYPES AREA */

// CORE DATA SECTION
type CoreData = {
  reference: string | null;
  const_a: string | null;
  const_b: string | null;
  const_c: string | null;
};

// IMAGE DATA SECTION
type ImageData = Pick<ImageBasic<'image_url'>, 'image_url'>;

// REGISTRY DATA SECTION
type RegistryData =
  | NameRegID<SpeciesID.WHEAT, 'TRIGO'>
  | NameRegID<SpeciesID.SOYBEAN, 'SOJA'>
  | NameRegID<SpeciesID.SUNFLOWER, 'GIRASOL'>
  | NameRegID<SpeciesID.SORGHUM, 'SORGO'>
  | NameRegID<SpeciesID.RICE, 'ARROZ'>
  | NameRegID<SpeciesID.CORN, 'MAÍZ'>
  | NameRegID<SpeciesID.BARLEY, 'CEBADA'>
  | NameRegID<SpeciesID.BEAN, 'POROTO'>
  | NameRegID<SpeciesID.SESAME, 'SESAMO'>
  | NameRegID<SpeciesID.CHIA, 'CHIA'>
  | NameRegID<SpeciesID.MILLET, 'MILHETO'>
  | NameRegID<SpeciesID.RYE, 'CENTENO'>;

// LOCALE DATA SECTION (PT)
type LocaleReg<TID, TVAL, TLANG> = DescriptionRegID<number, TVAL> &
  HardcodedFK<'silobag_species_type_id', TID> &
  HardcodedFK<'language_id', TLANG>;
type RegES<TID, TVAL> = LocaleReg<TID, TVAL, LanguageTypeID.ES>;
type RegPT<TID, TVAL> = LocaleReg<TID, TVAL, LanguageTypeID.PT>;

type ES =
  | RegES<SpeciesID.WHEAT, 'TRIGO'>
  | RegES<SpeciesID.SOYBEAN, 'SOJA'>
  | RegES<SpeciesID.SUNFLOWER, 'GIRASOL'>
  | RegES<SpeciesID.SORGHUM, 'SORGO'>
  | RegES<SpeciesID.RICE, 'ARROZ'>
  | RegES<SpeciesID.CORN, 'MAÍZ'>
  | RegES<SpeciesID.BARLEY, 'CEBADA'>
  | RegES<SpeciesID.BEAN, 'POROTO'>
  | RegES<SpeciesID.SESAME, 'SESAMO'>
  | RegES<SpeciesID.CHIA, 'CHIA'>
  | RegES<SpeciesID.MILLET, 'MILHETO'>
  | RegES<SpeciesID.RYE, 'CENTENO'>
  | RegES<SpeciesID.CHICKPEA, 'GARBANZO'>
  | RegES<SpeciesID.SAFFLOWER, 'CARTAMO'>
  | RegES<SpeciesID.OATMEAL, 'AVENA'>
  | RegES<SpeciesID.PEA, 'ARVEJA'>;

type PT =
  | RegPT<SpeciesID.WHEAT, 'TRIGO'>
  | RegPT<SpeciesID.SOYBEAN, 'SOJA'>
  | RegPT<SpeciesID.SUNFLOWER, 'GIRASSOL'>
  | RegPT<SpeciesID.SORGHUM, 'SORGO'>
  | RegPT<SpeciesID.RICE, 'ARROZ'>
  | RegPT<SpeciesID.CORN, 'MILHO'>
  | RegPT<SpeciesID.BARLEY, 'CEVADA'>
  | RegPT<SpeciesID.BEAN, 'FEIJÃO'>
  | RegPT<SpeciesID.SESAME, 'GERGELIM'>
  | RegPT<SpeciesID.CHIA, 'CHIA'>
  | RegPT<SpeciesID.MILLET, 'MILHETO'>
  | RegPT<SpeciesID.RYE, 'CENTEIO'>
  | RegPT<SpeciesID.CHICKPEA, 'GRÃO DE BICO'>
  | RegPT<SpeciesID.SAFFLOWER, 'CÁRTAMO'>
  | RegPT<SpeciesID.OATMEAL, 'AVEIA'>
  | RegPT<SpeciesID.PEA, 'ERVILHA'>;
